import React, { useRef, useEffect, useState } from 'react';
// import "../../assets/styles/typeConfirm.css";
import "../../assets/styles/handleConfirm.css";

import { motion } from "framer-motion";
import Header from "../../components/Header.js";
import imgConfirmFile from "../../imgs/img-confirm-file.png";
import imgConfirmSms from "../../imgs/img-confirm-sms.png";
import InfoUser from "../../components/Profile/InfoUser.js";
import imgBtnUser from "../../imgs/bt-change-name.png";
import imgBtnUserHover from "../../imgs/bt-change-name-hover.png";
import imgBtnPhone from "../../imgs/bt-change-phone.png";
import imgBtnPhoneHover from "../../imgs/bt-change-phone-hover.png";
import imgBtnMail from "../../imgs/bt-change-mail.png";
import imgBtnMailHover from "../../imgs/bt-change-mail-hover.png";
import imgBtnBank from "../../imgs/bt-change-bank.png";
import imgBtnBankHover from "../../imgs/bt-change-bank-hover.png";
import Collapsible from "react-collapsible";
import imgBottom from "../../imgs/img-bottom-cskh.png";
import imgBtnBirthday from "../../imgs/bt-change-birtday.png";
import iconFailed from "../../icons/icon-failed.png";
import iconSuccess from "../../icons/icon-success.png";
import iconCopy from "../../icons/icon-copy.png";
import Loading from "../../components/helper/Loading.js"
import { checkLastPhoneNumber, apiFormUpdateAccount, checkStatusUpdate } from "../../services/api.service.js";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import gifLoading from "../../imgs/gif/loading.gif"

import * as yup from 'yup';


function HandleConfirm() {
  const location = useLocation();
  const { userName, submitData, webSetting, data: initialData, sendType, resCheckDataOld } = location.state || {};
  const [data, setData] = useState(initialData);
  const submittedRequestId = useRef(null);
  const [files, setFiles] = useState([]);
  const [filesSend, setFilesSend] = useState([]);
  const [selected, setSelected] = useState("option1");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const fileRef = useRef(null);

  const shouldNavigate =(!submitData || submitData === "undefined");
  useEffect(() => {
    if (shouldNavigate) {
      navigate('/');
    }
  }, [navigate, shouldNavigate]);

  if (!shouldNavigate) {
    let messages = resCheckDataOld.requestImg;
    let text_confirm = "XÁC NHẬN"
    if (sendType === "phone_number") {
      messages = ["Vui lòng đính kèm hình ảnh đã gửi tin nhắn thành công!"];
      if (submitData.update_type == "phone_number") {
        messages = ["Vui lòng đính kèm hình ảnh đã gửi tin nhắn thành công!", "Hình ảnh chứng minh số điện thoại mới đang sử dụng (ví dụ: tin nhắn tra soát số điện thoại với nhà mạng)"];
      }
      if (submitData.update_type === "confirm_account") {
        messages = [...resCheckDataOld.requestImg, { description: "Vui lòng đính kèm hình ảnh đã gửi tin nhắn thành công!", type: "img" }];
      }
      text_confirm = "TÔI ĐÃ GỬI TIN NHẮN THÀNH CÔNG";
    }
    messages = messages.map((item) => typeof item === "string" ? { description: item } : item);
    const message = `${data.account} xac nhan ${resCheckDataOld.idVerify}`;

    const handleCopy = (text) => {
      navigator.clipboard.writeText(text);
      alert("Đã copy!");
    };

    const handleSelectFile = (index) => {
      fileRef.current.dataset.index = index;
      fileRef.current.accept = messages[index].type === "video" ? "video/*" : messages[index].type === "img" ? "image/*" : "";
      fileRef.current.value = "";
      fileRef.current.click();
    };

    const handleFileChange = (e) => {
      const index = e.target.dataset.index;
      const file = e.target.files[0];
      if (!file) return;
      const type = messages[index]?.type;
      if ((type === "video" && !file.type.startsWith("video/")) ||
          (type === "img" && !file.type.startsWith("image/"))) {
        Swal.fire({
          icon: "error",
          title: "File không đúng định dạng",
          text: type === "video" ? "Vui lòng chọn video cho mục này." : "Vui lòng chọn hình ảnh cho mục này.",
        });
        return;
      }
      if (file.size > 49 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: "Thất bại!",
          text: `File ${file.name} vượt quá giới hạn 50MB.`,
        });
        return false;
      }
      const newFile = {
        ...file,
        url: URL.createObjectURL(file),
        type: file.type.startsWith("image") ? "image" : "video",
      };
      setFilesSend((prev) => {
        const copy = [...prev];
        copy[index] = file;
        return copy;
      });
      setFiles((prev) => {
        const copy = [...prev];
        copy[index] = newFile;
        return copy;
      });
    };
    const startPolling = async (count_callback=1) => {
      try {
        console.log("check")
        const resCheck = await checkStatusUpdate(userName, resCheckDataOld.idVerify);
        const status = resCheck?.status;
        if (status && status !== "no_process") {
          const requestId = submittedRequestId.current;
          setData((previous) => ({
            ...previous,
            recent_requests: (previous?.recent_requests || []).map((request) =>
              requestId && request._id === requestId ? { ...request, status } : request
            ),
          }));
          Swal.close();
          Swal.fire({
            html: `
              <div style="text-align:center">
                <img src="${status == "approved" ? iconSuccess : iconFailed}" style="width:120px;margin-bottom:12px" />
                <p class="title-await-verify">CẬP NHẬT THÔNG TIN ${status == "approved" ? "" : "KHÔNG "} THÀNH CÔNG </p>
                <p>${resCheck?.message}</p>
                ${resCheck?.password ? `
                  <p>
                    <b style="color:#FC8B00">${resCheck.password}</b>
                    <span class="copy-btn" style="cursor:pointer;margin-left:6px;">
                      <img class="icon-copy" src="${iconCopy}" />
                    </span>
                  </p> `
                  : ``
                }
              <button class="btn-end" id="go-page-btn">
                ok
              </button>
              </div>
            `,
            showConfirmButton: false,
            allowOutsideClick: false,
            confirmButtonText: "OK",
            allowEscapeKey: false,
            allowEnterKey: false,
            didOpen: () => {
              const btn = document.getElementById("go-page-btn");
              if (btn) {
                btn.onclick = () => {
                  window.location.href = (status == "approved") ? webSetting.link_home : webSetting.link_cskh;
                };
              }
              const copyBtn = document.querySelector(".copy-btn");
              if (copyBtn) {
                copyBtn.onclick = () => {
                  navigator.clipboard.writeText(resCheck?.password || "");
                };
              }
            }
          });
        } else {
          const note = resCheck?.note || resCheck?.message;
          if (status === "no_process" && typeof note === "string" && note.trim()) {
            const title = Swal.getHtmlContainer()?.querySelector("#pending-verification-title");
            if (title) title.textContent = note;
            Swal.getHtmlContainer()?.querySelector("#pending-verification-description")?.remove();
          }
          count_callback = count_callback + 1
          if (count_callback < 60) {
            // gọi lại sau 10s
            setTimeout(() => {
              startPolling(count_callback);
            }, 10000);
          } else {
            Swal.fire({
              icon: "error",
              title: "Đơn yêu cầu của quý khách chưa được xử lý",
              text: "Yêu cầu của quý khách đang được tiếp nhận, vui lòng thử lại hoặc liên hệ CSKH để được xử lý nhanh chóng!",
            });
          }
        }
      } catch (e) {
        count_callback = count_callback + 1
        if (count_callback < 60) {
          setTimeout(() => {
            startPolling(count_callback);
          }, 10000);
        }
      }
    };

    // submit
    const handleConfirm = async () => {
      if (messages.some((item, index) => !filesSend[index])) {
        alert("Vui lòng tải lên đầy đủ hình ảnh/video yêu cầu!");
        return;
      }
      setLoading(true)
      submitData.id_verify = resCheckDataOld.idVerify;
      let resUpdateInfo = await apiFormUpdateAccount(submitData, filesSend);
      setLoading(false)
      if (resUpdateInfo) {
        submittedRequestId.current = resUpdateInfo.id;
        setData((previous) => ({
          ...previous,
          recent_requests: [{
            _id: resUpdateInfo.id,
            update_type: submitData.update_type,
            id_verify: `xxxxxx${resCheckDataOld.idVerify.slice(-2)}`,
            status: "no_process",
          }, ...(previous?.recent_requests || [])].slice(0, 2),
        }));
        try {
          Swal.fire({
            html: `
              <div style="text-align:center">
                <img src="${gifLoading}" style="width:120px;margin-bottom:12px" />
                <p id="pending-verification-title" class="title-await-verify">CHỜ XÁC MINH...</p>
                <p>Mã yêu cầu: <strong>${resCheckDataOld.idVerify}</strong></p>
                <p>Vui lòng lưu mã để tra cứu kết quả xử lý.</p>
                <p id="pending-verification-description">Hệ thống đang kiểm tra thông tin </br>
                Vui lòng chờ từ 1-5 phút... </p>
              </div>
            `,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            didOpen: () => {
              startPolling(0);
            },
          });
        } catch (error) {
          console.error("Error fetching code:", error);
        }
      }
    };

    const handleCancel = () => {
      navigate("/change-info",{ state: {...location.state, data}, replace: !!location.state?.lastBank });
      console.log("Quay lại");
    };
    return (
      <div className="container">
        {(loading) && (
          <Loading loading={loading}/>
        )}
        <motion.div
          className="app"
          initial={{ x: "100vw", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: "-100vw", opacity: 0 }}
          // transition={{ type: "spring", stiffness: 1000, damping: 200, duration: 10 }}
        >
        <Header isPageSearch={false} pageToAcction={"/change-info"} data={ {...location.state, data} }/>
        <div className="content">
          <p>Mã yêu cầu: <strong>{resCheckDataOld.idVerify}</strong>. Vui lòng lưu mã để tra cứu kết quả sau khi gửi.</p>
          {sendType === "phone_number" ? (
            <>
              <p>
                Vui lòng sử dụng số điện thoại <b style={{ color: "#FC8B00" }}>{resCheckDataOld.requestByPhone}</b> và soạn tin
                nhắn gửi đến số <b style={{ color: "#FC8B00" }}>{webSetting.phone_number}</b> với cú pháp sau:
              </p>
              <div className="box">
                <pre>{message}</pre>
                <img className="icon-copy" onClick={() => handleCopy(message)} src={iconCopy} alt="icon-copy" />
              </div>
              <p>
                Gửi đến: <b style={{ color: "#FC8B00" }}>{webSetting.phone_number}</b>
                <span onClick={() => handleCopy(webSetting.phone_number)} style={{ cursor: "pointer" }}>
                  <img className="icon-copy" src={iconCopy} alt="icon-copy" />
                </span>
              </p>
            </>
          )
          :
          (
            <p>
              Vui lòng tải lên đầy đủ các hình ảnh sau để xác thực:
            </p>
          )}
          <input
            type="file"
            ref={fileRef}
            hidden
            onChange={handleFileChange}
          />
          {messages.map((msg, index) => (
            <div key={index}>
              <p style={{ color: "red" }}>♦ {msg.description}</p>

              <div className="upload" onClick={() => handleSelectFile(index)}>
                {files[index] ? (
                  files[index].type === "image" ? (
                    <img
                      src={files[index].url}
                      alt={`preview-${index}`}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        borderRadius: 4,
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <video
                      src={files[index].url}
                      controls
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        borderRadius: 4,
                        objectFit: "cover",
                      }}
                    />
                  )
                ) : (
                  <p>{msg.type === "video" ? "⬆️ Tải lên video" : "⬆️ Tải lên ảnh"}</p>
                )}
              </div>
            </div>
          ))}
          <div className="btn-handle-confirm">
            <button className="btn-confirm" onClick={handleConfirm}>
              {text_confirm}
            </button>

            <button className="btn-cancel" onClick={handleCancel}>
              QUAY LẠI
            </button>
          </div>
        </div>
        </motion.div>
      </div>
    );
  }
}

export default HandleConfirm;
